import Component from './EmptyState.vue';

export default {
  install(Vue) {
    Vue.component('BkfEmptyState', Component);
  },
};
